'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Divider = require('@narvar/nth-bit-divider');
var ClaimDetailsViewRoot = require('./ClaimDetailsViewRoot.js');
var IframeHeight = require('../../components/IframeHeight.js');
var ClaimDetailsProvider = require('./ClaimDetailsProvider.js');
var ViewWrapper = require('../../components/ViewWrapper.js');
var Loading = require('../../../../common/components/Loading.js');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var ClaimDetailsNav = require('./components/ClaimDetailsNav.js');
var Overview = require('./sections/Overview.js');
var Evaluations = require('./sections/Evaluations.js');
var index$1 = require('./sections/Shipments/index.js');
var Box = require('../../../../common/components/layout/Box/Box.js');
var Customer = require('./sections/Customer.js');
var index = require('./sections/Review/index.js');
var Banner = require('../../../../common/components/Banner/Banner.js');
var PermissionsProvider = require('../../providers/permissions/PermissionsProvider.js');
var useTitanAnalytics = require('../../../../common/providers/titan/useTitanAnalytics.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Divider__default = /*#__PURE__*/_interopDefaultLegacy(Divider);

const ClaimDetails = _ref => {
  let {
    claim
  } = _ref;
  const titan = useTitanAnalytics["default"]();
  const {
    updateClaimError,
    updateClaimSuccess
  } = ClaimDetailsProvider.useClaimDetails();
  const {
    claimsClaimDetailsReviewSubmitError,
    claimsClaimDetailsReviewSubmitSuccess
  } = nthHookTranslations.useTranslations();
  const {
    updateClaim: canUpdateClaim
  } = PermissionsProvider.usePermissions();
  const showReviewSection = canUpdateClaim || !canUpdateClaim && !!(claim !== null && claim !== void 0 && claim.resolution);
  React.useEffect(() => {
    // Note: This effect is only called on first component render
    titan === null || titan === void 0 ? void 0 : titan.track({
      event: 'product_viewed',
      properties: {
        product_id: claim === null || claim === void 0 ? void 0 : claim.id,
        category: claim === null || claim === void 0 ? void 0 : claim.claimType,
        variant: claim === null || claim === void 0 ? void 0 : claim.status
      }
    })
    // eslint-disable-next-line no-console
    .catch(e => console.error(e));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 3
  }, /*#__PURE__*/React__default["default"].createElement(ClaimDetailsNav["default"], null), updateClaimError && /*#__PURE__*/React__default["default"].createElement(Banner["default"], {
    type: "error"
  }, claimsClaimDetailsReviewSubmitError), updateClaimSuccess && /*#__PURE__*/React__default["default"].createElement(Banner["default"], {
    type: "success"
  }, claimsClaimDetailsReviewSubmitSuccess), /*#__PURE__*/React__default["default"].createElement(Overview["default"], {
    claim: claim
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      width: '100%',
      margin: '0.75rem 0 0.5rem 0'
    }
  }, /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], null)), /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 6
  }, /*#__PURE__*/React__default["default"].createElement(Evaluations["default"], {
    claim: claim
  }), showReviewSection && /*#__PURE__*/React__default["default"].createElement(index["default"], {
    claim: claim
  }), /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    claim: claim
  }), /*#__PURE__*/React__default["default"].createElement(Customer["default"], {
    claim: claim
  })));
};

// This component allows us to render the above ClaimDetails component only when the claim details are loaded.
// This allows us to confidently only call the titan product viewed event on first render with the claim details
const ClaimDetailsLoader = () => {
  const {
    claim
  } = ClaimDetailsProvider.useClaimDetails();
  const contentRef = React.useRef(null);
  const {
    updateClaimSuccess
  } = ClaimDetailsProvider.useClaimDetails();
  const {
    claimDetailsLoading,
    updateClaimLoading
  } = ClaimDetailsProvider.useClaimDetails();
  const {
    claimsClaimDetailsLoading,
    claimsClaimDetailsReviewSubmitLoading
  } = nthHookTranslations.useTranslations();
  React.useLayoutEffect(() => {
    if (updateClaimSuccess) {
      var _contentRef$current, _contentRef$current2;
      (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.scrollTo(0, 0);
      (_contentRef$current2 = contentRef.current) === null || _contentRef$current2 === void 0 ? void 0 : _contentRef$current2.focus();
    }
  }, [updateClaimSuccess]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      maxWidth: '23rem',
      margin: '0 auto'
    }
  }, /*#__PURE__*/React__default["default"].createElement(Loading["default"], {
    loading: claimDetailsLoading || !!updateClaimLoading,
    text: claimDetailsLoading && claimsClaimDetailsLoading || updateClaimLoading && claimsClaimDetailsReviewSubmitLoading || ''
  }, /*#__PURE__*/React__default["default"].createElement(ViewWrapper.ViewWrapperRoot, {
    contentScrollable: true
  }, /*#__PURE__*/React__default["default"].createElement(ViewWrapper.ViewWrapperContent, {
    contentScrollable: true,
    ref: contentRef
  }, claim && /*#__PURE__*/React__default["default"].createElement(ClaimDetails, {
    claim: claim
  })), /*#__PURE__*/React__default["default"].createElement(ViewWrapper.ViewWrapperBottomBar, null))));
};
const ClaimDetailsWithViewRoot = () => /*#__PURE__*/React__default["default"].createElement(ClaimDetailsViewRoot["default"], null, /*#__PURE__*/React__default["default"].createElement(IframeHeight["default"], null, /*#__PURE__*/React__default["default"].createElement(ClaimDetailsLoader, null)));
var ClaimDetails$1 = nthHookTranslations.withTranslationsProvider(ClaimDetailsWithViewRoot, {
  translationKeys: ['claimsClaimDetailsLoading', 'claimsClaimDetailsReviewSubmitLoading', 'claimsClaimDetailsReviewSubmitError', 'claimsClaimDetailsReviewSubmitSuccess']
});

exports["default"] = ClaimDetails$1;
